import React, { useEffect, useState } from "react";
import {
  AADHAR_REJECT_REASON_OPTIONS,
  APPROVE,
  APPROVE_REJECT_OPTIONS,
  REJECT,
} from "../../../../constants";

import Dropdown from "../../../../UI/Dropdown/Dropdown";

import Accordion from "../../../../UI/Accordion";
import Chip from "../../../../UI/Chip";
import Modal from "../../../../UI/Modal";
import RadioGroup from "../../../../UI/RadioGroup";
import {
  DividerContainer,
  DPImage,
  Header,
  LeftContainer,
  RightContainer,
  DPImageWrapper,
  DPPanImage,
} from "../../../../styles/commonStyles";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  approveQcDetails,
  getQcAdditionalData,
  getQcDetails,
  resetState,
  saveQcDetails,
  setQcDetails,
} from "../../../../../../store/actions/QcDetails";
import { evaluatePerms, isEmpty } from "../../../../utils";
import { isAnyStepRejected, isFieldEditable } from "../../../../utils/helper";
import { set } from "lodash-es";
import { getPath } from "../../../../../../utils";
import MenuNames from "../../../../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../../../../constants/Menu/MenuActionsMappings";

const qcWriteRole = MenuActionsMappings[MenuNames.QUALITY_CHECK_V2].WRITE;

const Step1 = ({
  qcDetails,
  initialState,
  setInitialState,
  getPhotoVerificationError,
  removePhotoVerificationError,
  allMenuActions,
  photoVerificationSteps,
  stepNum = 1,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [radioValue, setRadioValue] = useState(null);
  const [rejectionReason, setRejectionReason] = useState(null);

  const rejectionDropdownId = "basic_details.driver_photo.rejection_reason";

  const isTerminated = qcDetails?.driver_lifecycle_status === "terminated";
  const isRejectSelected = radioValue === REJECT;

  const driverDetails = qcDetails.basic_details?.driver_photo;

  const panDetails = qcDetails.document_details?.pan_card_doc;
  const aadharDetails = qcDetails.document_details?.aadhar_card_doc;
  const isAutoVerified = driverDetails?.auto_verify;
  const panPhotoStatus = panDetails?.photo_match_status;
  const aadharPhotoStatus = aadharDetails?.photo_match_status;

  const isPan = isEmpty(aadharDetails);
  const AadharOrPanText = isPan ? "PAN" : "Aadhar";

  const actionHasBeenDone = !isEmpty(driverDetails?.verified);

  useEffect(() => {
    if (actionHasBeenDone) {
      const isRejected = !driverDetails?.verified;
      setRadioValue(isRejected ? REJECT : APPROVE);
      isRejected && setRejectionReason(driverDetails?.rejection_reason);
    }
  }, [qcDetails]);

  const anyStepsRejected = isAnyStepRejected(qcDetails, photoVerificationSteps);

  const hasWritePermissions = evaluatePerms([qcWriteRole], allMenuActions);

  const isFormEditable =
    isFieldEditable("driver_photo", qcDetails) &&
    !isTerminated &&
    hasWritePermissions;

  const getAccordionState = () => {
    if ((actionHasBeenDone && !anyStepsRejected) || isAutoVerified) {
      return driverDetails?.verified || isAutoVerified ? "success" : "error";
    } else {
      return driverDetails?.verified === false ? "error" : "default";
    }
  };

  const updateDriverPhoto = (newDriverDetails) => {
    const newInitialState = JSON.parse(JSON.stringify(initialState));
    set(newInitialState, "basic_details.driver_photo", newDriverDetails);
    setInitialState(newInitialState);
  };

  const handleRadioChange = (value) => {
    setRadioValue(value);

    const newDriverDetails = getPath(
      initialState,
      "basic_details.driver_photo"
    );
    newDriverDetails.verified = value === APPROVE;

    if (value === APPROVE) {
      removePhotoVerificationError(rejectionDropdownId);
      setRejectionReason(null);
      newDriverDetails.rejection_reason = null;
    }

    updateDriverPhoto(newDriverDetails);
  };

  const handleDropdownChange = (value) => {
    setRejectionReason(value);

    if (!isEmpty(value)) {
      removePhotoVerificationError(rejectionDropdownId);
    }

    const newDriverDetails = getPath(
      initialState,
      "basic_details.driver_photo"
    );
    newDriverDetails.rejection_reason = value;

    updateDriverPhoto(newDriverDetails);
  };

  const dropdownError = getPhotoVerificationError(rejectionDropdownId);

  useEffect(() => {
    if (!isEmpty(dropdownError)) {
      setIsAccordionOpen(true);
    }
  }, [dropdownError]);

  useEffect(() => {
    if (!actionHasBeenDone && !isAutoVerified && !isTerminated) {
      setIsAccordionOpen(true);
    } else {
      setIsAccordionOpen(false);
    }
  }, [actionHasBeenDone, isAutoVerified]);

  return (
    <Accordion
      title={`Step ${stepNum}: Aadhar/PAN photo verification`}
      redBorder={!isEmpty(dropdownError)}
      isOpen={isAccordionOpen}
      setIsOpen={setIsAccordionOpen}
      state={getAccordionState()}
      disabled={anyStepsRejected || isAutoVerified || isTerminated}
      canOpen={!isAutoVerified}
    >
      <Modal
        open={modelOpen}
        setOpen={setModelOpen}
        title="Aadhar/PAN photo verification"
      >
        <DPImageContainer>
          <ImageLabelWrapper>
            <DPImageWrapper>
              <DPImage size="md" src={driverDetails?.url} />
            </DPImageWrapper>
            <ImageLabel>Uploaded photo</ImageLabel>
          </ImageLabelWrapper>
          <ImageLabelWrapper>
            <DPImageWrapper>
              {isEmpty(aadharDetails) ? (
                <DPPanImage size="md" src={panDetails?.url} />
              ) : (
                <DPImage size="md" src={aadharDetails?.url} />
              )}
            </DPImageWrapper>
            <ImageLabel>{AadharOrPanText} photo</ImageLabel>
          </ImageLabelWrapper>
        </DPImageContainer>
      </Modal>
      <DividerContainer>
        <LeftContainer>
          <Header>Uploaded photo</Header>
          <DPImage
            onClick={() => setModelOpen(true)}
            src={driverDetails?.url}
          />

          <RadioGroup
            value={radioValue}
            onChange={handleRadioChange}
            options={APPROVE_REJECT_OPTIONS}
            disabled={!isFormEditable}
          />
        </LeftContainer>
        <RightContainer>
          <Header>{AadharOrPanText} photo</Header>
          {isEmpty(aadharDetails) ? (
            <DPPanImage
              onClick={() => setModelOpen(true)}
              src={panDetails?.url}
            />
          ) : (
            <DPImage
              onClick={() => setModelOpen(true)}
              src={aadharDetails?.url}
            />
          )}
          {isPan &&
            panPhotoStatus?.status !== "UNAVAILABLE" &&
            !isEmpty(panPhotoStatus) && (
              <Chip
                size="md"
                color={panPhotoStatus?.status}
                disabled={!isFormEditable}
              >
                {panPhotoStatus?.text}
              </Chip>
            )}

          {!isPan &&
            aadharPhotoStatus?.status !== "UNAVAILABLE" &&
            !isEmpty(aadharPhotoStatus) && (
              <Chip
                size="md"
                color={aadharPhotoStatus?.status}
                disabled={!isFormEditable}
              >
                {aadharPhotoStatus?.text}
              </Chip>
            )}
          {isRejectSelected && (
            <Dropdown
              options={AADHAR_REJECT_REASON_OPTIONS}
              placeholder="Select reason to reject"
              value={rejectionReason}
              id={rejectionDropdownId}
              onChange={handleDropdownChange}
              disabled={!isFormEditable}
              error={dropdownError}
            />
          )}
        </RightContainer>
      </DividerContainer>
    </Accordion>
  );
};

export const DPImageContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const ImageLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ImageLabel = styled.div`
  font-size: 18px;
  line-height: 24px;
`;

function mapStateToProps(state) {
  const { QcDetails, MenuActions } = state;
  return {
    qcDetails: QcDetails.qcDetails,
    currentActiveFeId: QcDetails.currentActiveFeId,
    qcRejectionReasons: QcDetails.qcRejectionReasons,
    qcDocTypes: QcDetails.qcDocTypes,
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getQcDetails: bindActionCreators(getQcDetails, dispatch),
    getQcAdditionalData: bindActionCreators(getQcAdditionalData, dispatch),
    saveQcDetails: bindActionCreators(saveQcDetails, dispatch),
    approveQcDetails: bindActionCreators(approveQcDetails, dispatch),
    setQcDetails: bindActionCreators(setQcDetails, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
